module.exports = __webpack_public_path__ + "img/flower-sun.1f5d9175.png";